import AbstractModule from './AbstractModule';
import { $window } from './../utils/environment';

export default class extends AbstractModule {
    constructor(options) {
        super(options);

        this.DEFAULT_WIDTH = 1920;
        this.DEFAULT_HEIGHT = 1080;

        this.init();
    }

    init() {
        this.overlay = $('.js-categories-overlay', this.$el);
        this.height = this.$window.height();

        $('.js-categories-label', this.$el).each((index, el) => {
            this.wordToLetters($(el), $(el).text());
        });

        $('.js-navigation-item', this.$el).on('mouseenter.NavigationCategories', (event) => {
            if (window.matchMedia('(max-width: 999px)').matches) {
                setTimeout(() => {
                    const $el = $(event.currentTarget).find('.js-navigation-link');
                    $el.css('pointer-events', 'auto');
                }, 300);
            }
        });
        $('.js-navigation-item', this.$el).on('mouseleave.NavigationCategories', (event) => {
            if (window.matchMedia('(max-width: 999px)').matches) {
                const $el = $(event.currentTarget).find('.js-navigation-link');
                $el.css('pointer-events', 'none');
            }
        });

        this.onResize();
        $window.on('resize.NavigationCategories', () => this.onResize());
    }

    onResize() {
        const ratioDefault = this.DEFAULT_WIDTH / this.DEFAULT_HEIGHT;
        const ratioCurrent = window.innerWidth / window.innerHeight;

        if (ratioDefault > ratioCurrent) {
            this.$el.addClass('-height').removeClass('-width');
        } else {
            this.$el.addClass('-width').removeClass('-height');
        }
    }

    wordToLetters($el, name) {
        $el.html('');

        // récréer le contenu en ajoutant les lettres
        // dans des balises `<span>LETTER</span>`
        for (let i = 0; i < name.length; i++) {
            if (i === 0) {
                $el.html(`<span class="-first">${name.charAt(i)}</span>`);
            } else {
                $el.html(`${$el.html()}<span>${name.charAt(i)}</span>`);
            }
        }
    }

    destroy() {
        this.$el.off('.NavigationCategories');
        $window.off('.NavigationCategories');
    }
}
